import ColumnItem from './ColumnItem';

import './ColumnItem.scss';

export default ColumnItem;
